(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celavi-reservations"]) return;
  try {
    

function setupCelavi(root){
 const success=root.querySelector('#CelaviSuccess');
 if(success){const show=()=>{success.scrollIntoView({block:'start',behavior:'auto'});success.focus({preventScroll:true});};requestAnimationFrame(show);if(document.readyState!=='complete')window.addEventListener('load',show,{once:true});return;}
 const form=root.querySelector('#CelaviReservation'), variant=root.querySelector('#CelaviVariant');
 if(!form||!variant||form.dataset.celaviReady)return;
 form.dataset.celaviReady='true';
 const rows=Array.from(variant.options).filter(o=>o.value).map(o=>({sku:o.value,style:o.dataset.style,colour:o.dataset.colour,size:o.dataset.size,label:o.textContent}));
 const style=root.querySelector('#CelaviStyle'),colour=root.querySelector('#CelaviColour'),filters=root.querySelector('#CelaviFilters'),status=root.querySelector('#CelaviChoiceStatus');
 const colourPlaceholder=colour.options[0].textContent;
 function reset(el,label){el.replaceChildren(new Option(label,''));}
 function sizes(){reset(variant,variant.dataset.sizePlaceholder);const matches=rows.filter(r=>r.style===style.value&&r.colour===colour.value);matches.sort((a,b)=>Number(a.size)-Number(b.size)).forEach(r=>variant.add(new Option(r.size,r.sku)));variant.disabled=!matches.length;status.textContent='';}
 function colours(){reset(colour,colourPlaceholder);Array.from(new Set(rows.filter(r=>r.style===style.value).map(r=>r.colour))).forEach(c=>colour.add(new Option(c,c)));colour.disabled=!style.value;sizes();}
 filters.hidden=false;style.disabled=false;style.required=true;colour.required=true;
 root.querySelector('#CelaviVariantLabel').textContent=root.querySelector('#CelaviVariantLabel').dataset.sizeLabel;
 style.addEventListener('change',colours);colour.addEventListener('change',sizes);colours();
 root.querySelectorAll('[data-celavi-style]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>{style.value=button.dataset.celaviStyle;colours();colour.value=button.dataset.celaviColour;sizes();status.textContent=style.selectedOptions[0].textContent+' / '+colour.value;form.scrollIntoView({block:'start',behavior:'auto'});variant.focus({preventScroll:true});});});
 form.addEventListener('submit',event=>{if(!variant.value||!style.value||!colour.value){event.preventDefault();variant.setCustomValidity(variant.dataset.sizePlaceholder);variant.reportValidity();}else{variant.setCustomValidity('');const choice=rows.find(r=>r.sku===variant.value);form.querySelector('[name="contact[body]"]').value='CeLaVi zahtjev za rezervaciju: '+choice.label;}});
 variant.addEventListener('change',()=>variant.setCustomValidity(''));
 const source=root.querySelector('#CelaviSource');if(source){const p=new URLSearchParams(location.search);source.value=['utm_source','utm_medium','utm_campaign','utm_content'].map(k=>k+'='+(p.get(k)||'').slice(0,120)).join('; ');}
}
document.querySelectorAll('.celavi-page').forEach(setupCelavi);
document.addEventListener('shopify:section:load',e=>{const root=e.target.querySelector('.celavi-page');if(root)setupCelavi(root);});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
